export default __webpack_public_path__ + "static/media/G0006.2ebe262e.png";